import type { ElementType, ReactNode } from 'react'
import { PLACEMENT, StatefulTooltip } from 'baseui/tooltip'
import ModulePictogram from './ModulePictogram/ModulePictogram'
import useModuleHeading from './useModuleHeading'
import { ModuleTitle, ModuleTitleGroup, RailButton } from './styled-components'

interface ModuleHeadingProps {
  icon: ElementType<{ size?: number }>
  moduleKey: string
  label?: string
  statusDotLabel?: string
  children: ReactNode
}

const ModuleHeading = ({ icon, moduleKey, label, statusDotLabel, children }: ModuleHeadingProps) => {
  const { rail, count, railLabel, onOpen } = useModuleHeading({ moduleKey, label, children })

  if (rail) {
    return (
      <StatefulTooltip content={children} placement={PLACEMENT.left} showArrow accessibilityType='tooltip'>
        <RailButton type='button' data-rail-module={moduleKey} aria-label={railLabel} onClick={onOpen}>
          <ModulePictogram icon={icon} count={count} moduleKey={moduleKey} statusDotLabel={statusDotLabel} />
        </RailButton>
      </StatefulTooltip>
    )
  }

  return (
    <ModuleTitleGroup>
      <ModulePictogram icon={icon} count={count} moduleKey={moduleKey} statusDotLabel={statusDotLabel} />
      <ModuleTitle>{children}</ModuleTitle>
    </ModuleTitleGroup>
  )
}

export default ModuleHeading
